/*
 * File: useGetPackages.ts
 * Author: Austin Robinson
 * Date Created: 2/11/2024
 * Copyright (c) DrivingDoc 2023
 */
import { createQuery } from 'react-query-kit';

import { publicApi } from 'api';

export interface GetPackagesResult {
  id: string;
  title: string;
  price: string;
  description?: string;
  services_included?: string[];
  courses: {
    id: string;
    title: string;
    performance_time_included: string;
    observation_time_included: string;
    total_cost: string;
    sections: {
      id: string;
      title: string;
      description?: string;
      location: string;
      seats_left: number;
      periods: {
        id: string;
        start: string;
        end: string;
      }[];
    }[];
  }[];
  isHighlighted: boolean;
  locations: {
    id: string;
    name: string;
    // remCapacity: string;
  }[];
}

async function getPackages(): Promise<GetPackagesResult[]> {
  // make api call
  const result = await publicApi.get('/public/packages');

  // return the data object
  return result.data as GetPackagesResult[];
}

const useGetPackages = createQuery({
  queryKey: ['public_packages'],
  fetcher: getPackages,
});

export { useGetPackages };
